import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zsmcx",
  "use": "icon-zsmcx-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-zsmcx\"><path d=\"M640 480a160 160 0 0 1 133.376 248.405333l113.216 112.938667-45.184 45.312-113.344-113.066667A160 160 0 1 1 640 480zM224 618.666667v181.333333H405.333333v64H160V618.666667h64zM640 544a96 96 0 1 0 0 192 96 96 0 0 0 0-192z m-234.666667-384v64h-181.333333V405.333333h-64V160H405.333333z m458.666667 0V405.333333h-64v-181.333333H618.666667v-64h245.333333z\" fill=\"#ffffff\" p-id=\"3637\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol